export default function WhyLoseClients() {
  const objections = [
    {
      title: 'Дорого',
      desc: 'Менеджер начинает оправдываться вместо продажи ценности.',
      icon: 'ri-money-dollar-circle-line',
    },
    {
      title: 'Нам нужно подумать',
      desc: 'Разговор заканчивается без следующего шага.',
      icon: 'ri-time-line',
    },
    {
      title: 'Работаем с другими',
      desc: 'Сотрудник боится задавать уточняющие вопросы.',
      icon: 'ri-building-line',
    },
    {
      title: 'Отправьте предложение',
      desc: 'Клиент получает КП и пропадает.',
      icon: 'ri-file-list-3-line',
    },
    {
      title: 'Нет бюджета',
      desc: 'Менеджер сразу предлагает скидку.',
      icon: 'ri-wallet-line',
    },
    {
      title: 'Нам это неинтересно',
      desc: 'Разговор завершается слишком быстро.',
      icon: 'ri-indeterminate-circle-line',
    },
    {
      title: 'Позвоните позже',
      desc: 'Отсутствует стратегия продолжения контакта.',
      icon: 'ri-phone-line',
    },
    {
      title: 'Нужно согласовать',
      desc: 'Менеджер теряет влияние на процесс принятия решения.',
      icon: 'ri-shield-check-line',
    },
  ];

  return (
    <section id="why-lose" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему сотрудники теряют клиентов именно на возражениях
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Каждое возражение — это точка, где продажа либо умирает, либо превращается в долгосрочное партнёрство. Вот что происходит сейчас в вашем отделе:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {objections.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:bg-teal-50 transition-colors duration-300 border border-gray-100 hover:border-teal-200">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}